export const getCurrentPosition = (): Promise<GeolocationCoordinates> =>
  new Promise<GeolocationCoordinates>((resolve) => {
    navigator.geolocation.getCurrentPosition((position) => {
      resolve(position.coords)
    })
  })
